var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuItemTranslationsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.075,
    height: 19.075,
    viewBox: "0 0 19.075 19.075",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M9.537,19.075H9.51A9.537,9.537,0,0,1,2.794,2.794,9.473,9.473,0,0,1,9.517,0h.041a9.537,9.537,0,0,1,6.723,16.281,9.472,9.472,0,0,1-6.716,2.794Zm1.974-1.987A7.81,7.81,0,0,0,17.293,10.4H13.83A14.114,14.114,0,0,1,11.511,17.088Zm-3.946,0A14.152,14.152,0,0,1,5.248,10.4H1.782A7.809,7.809,0,0,0,7.565,17.088Zm1.973-.225A12.46,12.46,0,0,0,12.091,10.4h-5.1A12.491,12.491,0,0,0,9.537,16.863ZM17.293,8.67A7.809,7.809,0,0,0,11.51,1.987,14.16,14.16,0,0,1,13.827,8.67Zm-5.2,0A12.493,12.493,0,0,0,9.537,2.212,12.463,12.463,0,0,0,6.985,8.67Zm-6.842,0A14.1,14.1,0,0,1,7.565,1.987,7.809,7.809,0,0,0,1.782,8.67Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuItemTranslationsIcon);
export default __webpack_public_path__ + "static/media/menu-item-translations-icon.d568570234878b4a38ecda7dfd4062ac.svg";
export { ForwardRef as ReactComponent };